import request from 'services/axios';

export const getListFarms = async () => {
  const {data}: {data: IListFarms} = await request.get(`/api/v2/farm/farms`);
  return data;
};
